import { DatastoreFakeConfig } from './datastore.config';

export function debugConsoleLog(
  config: DatastoreFakeConfig,
  message?: unknown,
  ...optionalParams: unknown[]
) {
  if (config.debug) {
    console.log(message, ...optionalParams);
  }
}

export function debugConsoleWarn(
  config: DatastoreFakeConfig,
  message?: unknown,
  ...optionalParams: unknown[]
) {
  if (config.debug) {
    console.warn(message, ...optionalParams);
  }
}
